<template>
    <div>
        <!-- Covered2Go top logo panel -->
        <nav id="top-panel">

            <!-- Social media banner -->
            <div class="container-fluid social">
                <div class="container level">
                    <div class="level-left">
                        <div class="level-item">
                            <a href="https://www.facebook.com/Covered2go" target="_blank"><i class="fab fa-facebook-square"/></a> |
                            <a href="https://twitter.com/covered2go" target="_blank"><i class="fab fa-twitter"/></a> |
                            <a href="https://www.instagram.com/covered2go" target="_blank"><i class="fab fa-instagram"/></a>
                        </div>
                    </div>
                    <!-- Customer hub -->
                    <div class="level-right">
                        <div v-if="!customer">
                            <button class="button is-info is-small customer-hub-btn" @click="siteData.customerLoginModalActive = true">
                                <i class="fas fa-user"></i>
                                Customer Hub
                            </button>
                        </div>
                        <div v-else>
                            <router-link :to="{name:'customerHome'}" tag="button" class="button is-info is-small customer-hub-btn" @click="siteData.customerLoginModalActive = true">
                                <i class="fas fa-user"></i>
                                {{`${customer.title} ${customer.surname}`}}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Top banner containing Logo -->
            <div class="container header">
                <div class="level">
                    <div class="level-item">
                        <router-link :to="{name:'home'}" oncontextmenu="return false;">
                            <picture>
                                <source srcset="../assets/logo-HD.webp" type="image/webp">
                                <source srcset="../assets/logo-HD.png" type="image/png">
                                <img id="logo-image" src="../assets/logo-HD.webp" loading="lazy" alt="covered2go">
                            </picture>
                        </router-link>
                    </div>
                    <!-- TrustPilot -->
                    <div class="level-item tp-item">
                        <div class="trustpilot-widget" data-locale="en-GB" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="50b7a9eb00006400051f090e" data-style-height="40px" data-style-width="100%" data-theme="light">
                            <a href="https://uk.trustpilot.com/review/covered2go.co.uk" target="_blank" rel="noopener">Trustpilot</a>
                        </div>
                    </div>
                    <!-- Get a quote -->
                    <div class="level-item quote-item">
                        <router-link tag="button" class="button get-a-quote is-info hvr-glow" :to="{name:'getQuote',query:{type:'ST'}}">
                            <i class="far fa-check-circle"/>
                            <strong>GET A QUOTE</strong>
                        </router-link>
                    </div>
                    <!-- Retrieve a quote -->
                    <div class="level-item retrieve-item">
                        <button class="button retrieve-a-quote is-primary is-info hvr-glow" @click="showPopup()">
                            <i class="far fa-check-circle"/>
                            <strong>RETRIEVE A QUOTE / RENEWAL</strong>
                        </button>
                    </div>
                </div>
                <div class="level trust">
                    <div class="level-item">
                        <picture>
                            <source srcset="../assets/images/icons/thumbsup.webp" type="image/webp">
                            <source srcset="../assets/images/icons/thumbsup.png" type="image/png">
                            <img src="../assets/images/icons/thumbsup.webp" loading="lazy" height="44" alt="Thumbs Up">
                        </picture>
                        95% Customer Satisfaction
                    </div>
                    <div class="level-item">
                        <picture>
                            <source srcset="../assets/images/icons/superior_rating.webp" type="image/webp">
                            <source srcset="../assets/images/icons/superior_rating.png" type="image/png">
                            <img src="../assets/images/icons/superior_rating.webp" loading="lazy" height="44" alt="Superior Rating">
                        </picture>
                        Superior Covid Cover Rating
                    </div>
                    <div class="level-item">
                        <picture>
                            <source srcset="../assets/images/icons/24_hr_emergency_assistance.webp" type="image/webp">
                            <source srcset="../assets/images/icons/24_hr_emergency_assistance.png" type="image/png">
                            <img src="../assets/images/icons/24_hr_emergency_assistance.webp" loading="lazy" height="44" alt="24 Hour Emergency Medical Assistance">
                        </picture>
                        24 Hour Emergency Medical Assistance
                    </div>
                    <div class="level-item">
                        <picture>
                            <source srcset="../assets/images/icons/established_10.webp" type="image/webp">
                            <source srcset="../assets/images/icons/established_10.png" type="image/png">
                            <img src="../assets/images/icons/established_10.webp" loading="lazy" height="44" alt="Established 10 years">
                        </picture>
                        Est. 10 Years
                    </div>
                </div>
            </div>
        </nav>
        <base-navigation-bar :siteData="siteData"/>
        <retrieve-quote-modal :siteData="siteData"/>
        <customer-hub-login-modal :siteData="siteData"/>
    </div>
</template>

<script>
    import BaseNavigationBar from "./common/BaseNavigationBar";
    import RetrieveQuoteModal from "./common/RetrieveQuoteModal";
    import CustomerHubLoginModal from "./customer-hub/CustomerHubLoginModal";
    import { mapGetters } from "vuex";
    import { maintenance } from "../mixins/maintenance";

    export default {
        name: "Header",
        props: ['siteData'],
        computed: {
            ...mapGetters({
                customer: 'customer',
            })
        },
        methods: {
            async showPopup() {

                await this.maintenanceCheck();

                if (this.check === 0) {
                    this.$router.push({name: 'maintenance'});
                } else {
                    this.siteData.retrieveModalActive = true;
                }
            }
        },
        mixins: [maintenance],
        components: {
            CustomerHubLoginModal,
            BaseNavigationBar,
            RetrieveQuoteModal
        }
    }
</script>

<style lang="scss" scoped>
    #logo-image {
        height: 80px;
        cursor: pointer;
        transition: 0.3s;
    }
    #logo-image:hover {
        opacity: 0.85;
    }
    #top-panel {
        height: 160px;
        margin: 0 !important;
    }
    .trust {
        color: $c2g_blue;
    }
    .trustpilot-widget {
        padding: 20px 0 0 0;
        right: 10px;
        margin-bottom: 20px;
    }
    .social {
        background-color: #eeeeee;
        padding-left: 10px;
        font-size: 22px;
        a {
            color: $c2g_blue;
            transition: 0.4s;
            margin: 2px 5px;
        }
        a:hover { color: $c2g_orange; }
    }
    .header {
        padding-top: 20px;
        padding-bottom: 30px;
    }

    // Buttons
    .get-a-quote {
        background: linear-gradient(170deg, #eb892e, $c2g_orange);
        border-color: $c2g_orange;
        width: 200px;
        height: 40px;
        strong {
            margin-left: 5px;
        }
    }
    .retrieve-a-quote {
        background: $c2g_blue;
        border-color: $c2g_blue;
        width: 300px;
        height: 40px;
        strong {
            margin-left: 5px;
        }
    }
    .customer-hub-btn {
        margin: 5px 0;
        transition: 0.3s;
        .fas {
            margin-right: 5px;
        }
    }
    .customer-hub-btn:hover {
        background-color: $c2g_orange !important;
        border-color: $c2g_orange !important;
    }

    // Hide top buttons on mobile
    @media screen and (max-width: $small_tablet_width) {
        .tp-item { display: none; }
        .trust { display: none; }
    }

    // Hide top buttons on mobile
    @media screen and (max-width: $mobile_width) {
        // .retrieve-item { display: none; }
        .tp-item { display: none; }
        .trust { display: none; }
        // .quote-item { display: none; }
        .level-right { margin-top: 5px !important; text-align: center; }
    }

    @media screen and (max-width: '768px') {
        #top-panel { 
            height: 220px; 
            .header {
                padding: 0 5px;
            }
        }
    }

</style>